module.exports = __webpack_public_path__ + "assets/media/june.a70d59e4.svg";